import { Box, Stack, SxProps, Theme } from '@mui/material';

import { COLORS } from '@/styles/tokens/colors';

export interface NavigationDotsProps {
  /** Total number of steps */
  steps: number;
  /** Current active step index (0-based) */
  activeStepIndex: number;
  /** Callback when a step dot is clicked */
  onStepClick?: (step: number) => void;
  /** Optional styles for the container */
  sx?: SxProps<Theme>;
}

export function NavigationDots({
  steps,
  activeStepIndex,
  onStepClick,
  sx,
}: NavigationDotsProps) {
  return (
    <Stack
      direction="row"
      spacing={1}
      justifyContent="center"
      alignItems="center"
      sx={sx}
    >
      {Array.from({ length: steps }).map((_, index) => {
        const isActive = index === activeStepIndex;
        return (
          <Box
            key={index}
            component="button"
            onClick={() => onStepClick?.(index)}
            aria-label={`Go to step ${index + 1}`}
            aria-current={isActive ? 'step' : undefined}
            sx={{
              width: 8,
              height: 8,
              padding: 0,
              border: 'none',
              borderRadius: '50%',
              cursor: 'pointer',
              backgroundColor: isActive ? COLORS.NAVY[600] : COLORS.NAVY[200],
              transition: 'background-color 0.3s ease',
              '&:hover': {
                backgroundColor: isActive ? COLORS.NAVY[600] : COLORS.NAVY[400],
              },
              '&:focus-visible': {
                outline: `2px solid ${COLORS.NAVY[600]}`,
                outlineOffset: '2px',
              },
            }}
          />
        );
      })}
    </Stack>
  );
}
